import { render, staticRenderFns } from "./cogs.vue?vue&type=template&id=6a3bf47c&"
import script from "./cogs.vue?vue&type=script&lang=js&"
export * from "./cogs.vue?vue&type=script&lang=js&"
import style0 from "./cogs.vue?vue&type=style&index=0&id=6a3bf47c&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a3bf47c')) {
      api.createRecord('6a3bf47c', component.options)
    } else {
      api.reload('6a3bf47c', component.options)
    }
    module.hot.accept("./cogs.vue?vue&type=template&id=6a3bf47c&", function () {
      api.rerender('6a3bf47c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reports/cogs.vue"
export default component.exports